export const LETTER_REGEX = /^(?=.*?[a-z])/;
export const UPPERCASE_REGEX = /^(?=.*?[A-Z])/;
export const LOWERCASE_REGEX = /^(?=.*?[a-z])/;
//eslint-disable-next-line
export const SPECIAL_REGEX = /^(?=.*[!"#$%&'()*+,\-\.\/:;<=>?@\[\\\]\^_`{|}~])/;

export const PASSWORD_REGEX =
  //eslint-disable-next-line
  /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!"#$%&'()*+,.\/:;<=>?@\[\\\]^_`{|}~-])[a-zA-Z0-9!"#$%&'()*+,.\/:;<=>?@\[\\\]^_`{|}~-]{8,64}$/;

export const NUMBER_REGEX = /[0-9]/;

export const POST_CODE_REGEX = /^[A-Z0-9\s-]+$/i;

export const EMAIL_REGEX = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

export const COMPANY_NAME_REGEX = /^[ A-Za-z0-9.&'+:,/()-]+$/;
export const REGISTRATION_NUMBER_REGEX = /^[-.,()?:'\/+\w\s]+$/;
export const ADDRESS_REGEX = /^[ A-Za-z0-9.&'+:,/()-]+$/;
export const CITY_REGEX = /^[ A-Za-z0-9.&'+:,/()-]+$/;
